import * as React from "react";
import {Block, Editor} from "slate";
import {EventManager} from "shared/core/Events/EventManager";
import {Point} from "shared/lib/slate";
import './RNTagsSlateRenderer.css';
import {RNTagGroupProps} from "shared/controls/RNTags/RNTagGroup";
import {RNTagItem} from "shared/controls/RNTags/RNTagItem";
import {RNTagGroupModel} from "shared/controls/RNTags/RNTagGroup.Model";
import {RNTagItemModel} from "shared/controls/RNTags/RNTagItem.Model";

export class RNTagsSlateRenderer extends React.Component<FieldPickerSlateRendererProps, FieldPickerSlateRendererState> {
    static defaultProps: Partial<FieldPickerSlateRendererProps> = {};

    constructor(props: FieldPickerSlateRendererProps) {
        super(props);
        this.state = {};
    }

    public render() {
        return (
            <span contentEditable={false} style={{display:'inline-block',verticalAlign:'text-bottom'}} className={'SlateField '+(this.props.SlateProps.isSelected?'rnFieldSelected':'')}
                  onClick={(e)=>{e.preventDefault();e.stopPropagation();this.Select()}} >
                    {this.GetFormattedLabel()}
                <span style={{display:'none'}}>
                        {this.props.SlateProps.children}
                    </span>
            </span>
        )
    }

    public GetFormattedLabel(){
        let fieldId=this.props.Node.data.get('FieldId');
        let subType=this.props.Node.data.get('SubType');

        let currentItem:RNTagItemModel=null;
        this.props.Tags.forEach(group=>group.Children.forEach(item=>{
            if(item.Item.Type==subType&&item.Item.Value==fieldId)
                currentItem=item;
        }));

        if(currentItem==null)
            return 'Unknown';
        return currentItem.Item.Label;
    }


    public Select(){
        this.props.Editor.select({anchor:Point.create({key:this.props.Node.key,offset:0}),focus:Point.create({key:this.props.Node.key,offset:0})});

    }

}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FieldPickerSlateRendererProps {
    Node:Block;
    Editor:Editor;
    SlateProps:any;
    Tags:RNTagGroupModel[];
}

interface FieldPickerSlateRendererState {

}

//#endregion "My Region"